<template>
    <b-modal
        :id="'school-modal' + this.school.id"
        :ref="'school-modal' + this.school.id"
        :title="$t('school.edit_school')"
        :ok-title="$t('common.save')"
        @ok="update"
        :cancel-title="$t('common.cancel')"
        cancel-variant="outline-primary"
        modal-class="apprentice-default-modal"
        @show="show">
        <b-form-group
            :label="$t('common.name')"
            label-for="name">
            <b-form-input
                id="name"
                v-model="name"
                required
                :placeholder="$t('common.name')"></b-form-input>
        </b-form-group>

        <b-form-group
            label="Type:"
            label-for="type">
            <b-form-select
                class="apprentice-primary-select"
                id="type"
                v-model="selected_school_type"
                :options="schoolTypesIn"
                text-field="name"></b-form-select>
        </b-form-group>

        <b-form-group
            :label="$t('common.street')"
            label-for="street">
            <b-form-input
                id="street"
                v-model="street"
                :placeholder="$t('common.street')"></b-form-input>
        </b-form-group>

        <b-form-group
            :label="$t('common.house_number')"
            label-for="streetnumber">
            <b-form-input
                id="streetnumber"
                v-model="streetnumber"
                :placeholder="$t('common.house_number')"></b-form-input>
        </b-form-group>

        <b-form-group
            :label="$t('common.city')"
            label-for="city">
            <b-form-input
                id="city"
                v-model="city"
                :placeholder="$t('common.city')"></b-form-input>
        </b-form-group>

        <b-form-group
            :label="$t('common.postal_code')"
            label-for="zipcode">
            <b-form-input
                id="zipcode"
                v-model="zipcode"
                :placeholder="$t('common.postal_code')"></b-form-input>
        </b-form-group>

        <b-form-group
            :label="$t('common.phone')"
            label-for="phone">
            <b-form-input
                id="phone"
                v-model="phone"
                :placeholder="$t('common.phone')"></b-form-input>
        </b-form-group>
    </b-modal>
</template>

<script>
import { ords } from '../../../app';

export default {
    name: 'design-2021-school-index-update-school-modal-component',

    props: {
        school: {
            type: Object,
            required: true,
        },
        schoolTypesIn: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            name: this.school.name,
            selected_school_type: this.school.school_type,
            city: this.school.city,
            street: this.school.street,
            streetnumber: this.school.streetnumber,
            zipcode: this.school.zipcode,
            phone: this.school.phone,
        };
    },

    methods: {
        show() {
            this.name = this.school.name;
            this.selected_school_type = this.school.school_type;
            this.city = this.school.city;
            this.zipcode = this.school.zipcode;
            this.street = this.school.street;
            this.streetnumber = this.school.streetnumber;
            this.phone = this.school.phone;
        },

        update() {
            let data = {
                name: this.name,
                school_type: this.selected_school_type,
                city: this.city,
                street: this.street,
                streetnumber: this.streetnumber,
                zipcode: this.zipcode,
                phone: this.phone,
            };

            this.alert.saving();

            this.axios
                .post(this.routes.schoolUpdate(this.school.id), data)
                .then((response) => {
                    ords.use('school').update(response.data, this.school.id);

                    this.alert.success();
                })
                .catch(() => {
                    this.alert.ajaxError(error);
                });
        },
    },
};
</script>

<style scoped></style>
